"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function usePreventBodyScroll(isZoomed, elm) {
    (0, react_1.useEffect)(function () {
        var originalOverflow = getComputedStyle(document.body).overflow || "auto";
        if (isZoomed) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = originalOverflow;
        }
        // Cleanup function to restore original style when component unmounts
        return function () {
            document.body.style.overflow = originalOverflow;
        };
    }, [isZoomed]);
    (0, react_1.useEffect)(function () {
        if (!elm)
            return;
        var preventScroll = function (e) {
            if (isZoomed && e.touches.length === 1) {
                e.preventDefault();
            }
        };
        if (isZoomed) {
            elm.addEventListener("touchmove", preventScroll, { passive: false });
        }
        return function () {
            elm.removeEventListener("touchmove", preventScroll);
        };
    }, [isZoomed, elm]);
}
exports.default = usePreventBodyScroll;
